<template>
  <div class="upgrade-membership relative" v-if="showView">
    <div class="upgrade-membership-img">
      <img :src="imgUrl" alt="upgrade membership" />
      <div class="title">{{ t("shell.home.upgradeMembership.title") }}</div>
    </div>
    <div class="entry-box">
      <div class="entry">
        <div
          class="entry-item flex items-center cursor-pointer"
          v-for="(item, index) in entryList"
          :key="index"
          :class="{ 'mb-11': index !== entryList.length - 1 }"
          @click="handleOnClick(item.url)"
        >
          <div class="flex items-center flex-1">
            <img :src="item.icon" class="w-6 mr-4" alt="" />
            {{ item.text }}
          </div>
          <IconifyIconOnline
            icon="material-symbols:arrow-right-rounded"
            width="24"
            height="24"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconCreditCard from "@consumerY/assets/icon/credit-card.png";
import IconAirline from "@consumerY/assets/icon/icon-airline.png";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { useUserStoreHook } from "@/store/modules/user";
import { optimizeQiniuImage } from "@/utils/tool";

const { t } = useI18n();
const router = useRouter();
const userStore = useUserStoreHook();
const { user } = storeToRefs(userStore);

const imgUrl = optimizeQiniuImage(
  "https://qiniu-uploads-cdn.charmdeer.com/uploaded/Fm_8J3LOc7COeufy-2RSIGw2ZF1r/UpgradeYourMembership.jpg"
);

const showView = computed(() => {
  return !user.value || user.value.loyaltyProgram?.ref?.type === "guest";
});

const entryList = computed(() => [
  {
    text: t("shell.home.upgradeMembership.byCard"),
    icon: IconCreditCard,
    url: "/credit-card-match"
  },
  {
    text: t("shell.home.upgradeMembership.byAirline"),
    icon: IconAirline,
    url: "/airline-match"
  }
]);

const handleOnClick = url => {
  router.push(url);
};

defineOptions({
  name: "UpgradeMembership"
});
</script>

<style scoped lang="scss">
.upgrade-membership {
  margin: 68px auto 188px;
  width: 1080px;
  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-family: Cormorant-Bold;
    font-weight: bold;
    font-size: 36px;
    color: #ffffff;
  }
  .entry-box {
    width: 540px;
    height: 192px;
    position: absolute;
    right: 40px;
    bottom: -86px;
    background: #ffffff;
    border-bottom: 4px solid #000b1e;
    padding: 48px;
    box-shadow: 0 0 27px 0 rgba(0, 0, 0, 0.1);
    .entry-item {
      font-family: Cormorant-Bold;
      font-weight: bold;
      font-size: 22px;
      color: #292929;
      line-height: 22px;
    }
  }
}
</style>
